import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BrightAiOmniSearchProvider } from '@brighthub/brightai-search';
import { OmniSearchResult } from '@brighthub/search';

import { environment } from '@brighthub/environment';
import { EmployeeSearchService } from './employee-search.service';
import {
  EmployeeSearchResultWrapperComponent
} from './employee-search-result-wrapper/employee-search-result-wrapper.component';
import { OktaUserInfo } from '@brightside/core/auth';

@Injectable({
  providedIn: 'root'
})
export class EmployeeSearchProvider extends BrightAiOmniSearchProvider<OktaUserInfo> {

  id = 'employee';
  label = 'Search for an Employee';
  override description = 'Search for an employee by full name, email, or okta id';
  override shortcut = '@employee';
  rolesAllowed = [`BrightAI_${environment.environment}_admin`];

  private employeeSearchSvc = inject(EmployeeSearchService);

  search(search: string): Observable<OmniSearchResult<OktaUserInfo>[]> {
    return this.employeeSearchSvc.queryEmployee(search).pipe(
      map((result) => {
        const searchResults = result.payload.users.map(employee => {
          return {description: `${employee.firstName} ${employee.lastName}`, title: 'Brightside Employee', data: employee}
        });
        return searchResults;
      })
    );
  }

  loadComponent = async () => EmployeeSearchResultWrapperComponent;

}
